import React, {createRef} from "react"
import NavigationItem from "../../components/NavigationItem"
import {faArrowLeft, faPersonBooth, faSpinner} from "@fortawesome/free-solid-svg-icons"
import {Http} from "../../mixins/http"
import {User} from "../../domain-models"
import Form from "../../mixins/form"
import App from "../App"
import Navigation from "../../components/Navigation"
import _ from "lodash"
import {relative} from "../../filters"
import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import Trans from '../../components/Trans'

type Props = {}
type State = {
  form: Form
  users: User[]
  emptyResult: boolean
  isSearching: boolean
}

class Impersonation extends React.Component<Props, State> {
  private userNameRef = createRef<HTMLInputElement>()

  constructor(props: Props) {
    super(props)
    this.state = {
      form: new Form({username: null}),
      users: [],
      emptyResult: false,
      isSearching: false
    }
  }

  search = _.debounce(async () => {
    this.setState({emptyResult: false, isSearching: true})
    const form = new Form({
      username: this.userNameRef.current ? this.userNameRef.current.value : null,
    })
    const users = await Http.post<User[]>('/searchUsers', {state: this, form})

    this.setState({users, emptyResult: !users.length, isSearching: false})
  }, 600)

  impersonate = async (userId: number) => {
   await Http.post('/impersonate', {state: this, form: new Form({userId})})

    window.location.href = '/'
  }

  render() {
    return (
      <App>
        <div className="block sm:flex overflow-y-scroll scrolling-smooth h-full">
          <Navigation>
            <NavigationItem key={'Zurück'} icon={faArrowLeft} title={'Zurück'} path={'/'} visible={true}/>
            <NavigationItem key={'Impersonation'} icon={faPersonBooth} title={'Impersonation'} path={'/impersonation'} visible={true}/>
          </Navigation>
          <div className="w-full h-full mt-0 container mx-auto mt-4">
            <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Benutzer suchen</Trans></label>
            <input name="username" onChange={this.search} ref={this.userNameRef} type="text" placeholder="Benutzername" className="shadow appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>

            <div className={'mt-4'}>
              {
                this.state.emptyResult ?
                  <p>
                    <Trans>Keine Benutzer gefunden.</Trans>
                  </p>
                  : null
              }

              {
                this.state.isSearching ?
                  <p>
                    <Icon icon={faSpinner} spin={true}/>
                  </p>
                  : null
              }

              {
                this.state.users.map((user: any) => (
                  <div key={user.ars_id}>
                    <hr className="border-t border-gray-400 w-full h-0 my-2 overflow-hidden"/>

                    <div className={'bg-white my-4 px-4 py-3 rounded-md'}>
                      <p>Id: <strong>{user.ars_id}</strong></p>
                      <p>Domain: <strong>{user.domain}</strong></p>
                      <p>Username: <strong>{user.domain}.{user.username}</strong></p>
                      <p><Trans>Letzter Login</Trans>: <strong>{relative(user.last_login)}</strong></p>
                      <div className={'mt-2'}>
                        <button onClick={() => this.impersonate(user.ars_id)} className={'bg-blue-600 text-white px-4 py-2 hover:bg-blue-700 rounded'}><Trans>Kontrolle übernehmen</Trans></button>
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </App>
    )
  }
}

export default Impersonation
